import React from 'react';
import styled from 'styled-components';
import useMonitoringData from '../hooks/useMonitoring';
import { fetchOverview } from '../api/monitoringApi';

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  @media (max-width: 1200px) { grid-template-columns: repeat(3, 1fr); }
  @media (max-width: 700px) { grid-template-columns: repeat(2, 1fr); }
  @media (max-width: 500px) { grid-template-columns: 1fr; }
`;

const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 1px 4px rgba(0,0,0,0.08);
  border-left: 4px solid ${p => p.$accent || 'transparent'};
`;

const Label = styled.div`font-size: 13px; color: #6b7280; margin-bottom: 4px;`;
const Value = styled.div`font-size: 28px; font-weight: 700; color: #111827;`;
const Sub = styled.div`font-size: 13px; color: ${p => p.$warn ? '#ef4444' : '#6b7280'}; margin-top: 4px;`;

export default function OverviewCards({ refreshKey }) {
  const { data, isLoading } = useMonitoringData(fetchOverview, [refreshKey]);
  if (isLoading || !data) return <Grid>{[1,2,3,4,5].map(i => <Card key={i}><Label>로딩 중...</Label></Card>)}</Grid>;

  const cards = [
    { label: '디보 회원', value: data.total_clients, sub: `활성: ${data.active_clients}명` },
    { label: '총 사이트', value: data.total_sites, sub: `활성: ${data.active_sites}개` },
    { label: '총 구독', value: data.total_subscribes, sub: `활성: ${data.active_subscribes}건` },
    {
      label: '구독 전환율',
      value: `${data.subscription_conversion_rate ?? 0}%`,
      sub: `구독: ${data.subscribed_clients}명 · 미구독: ${data.unsubscribed_clients}명`,
      accent: '#10b981',
    },
    {
      label: '오늘 API 요청',
      value: data.today_api_requests?.toLocaleString(),
      sub: `에러: ${data.today_error_count}건 (${data.today_error_rate}%)`,
      warn: data.today_error_rate > 5,
    },
  ];

  return (
    <Grid>
      {cards.map((c, i) => (
        <Card key={i} $accent={c.accent}>
          <Label>{c.label}</Label>
          <Value>{c.value}</Value>
          <Sub $warn={c.warn}>{c.sub}</Sub>
        </Card>
      ))}
    </Grid>
  );
}
